/* @ngInject */
export function SafetyTrainingPresentationFactory() {
    return function SafetyTrainingPresentation() {
        this.id = null;
        this.name = null;
        this.description = null;
        this.trainingType = null;
    };
}
